<template>
    <!-- page content -->
    <iframe style="margin-top: 30px" width="100%" :src="$config.analyticUrl"></iframe>
    <!-- /page content -->
</template>

<script>
    export default {
        name: "home"
    }
</script>